import {defineMessages} from "@project/i18n";

export const noteFieldLabelIds = {
  content: "fields.note.content",
  title: "fields.note.title",
} as const;

export const noteFieldMessages = defineMessages({
  content: {
    id: "fields.note.content",
    defaultMessage: "Content",
    description: "Note field label for content",
  },
  title: {
    id: "fields.note.title",
    defaultMessage: "Title",
    description: "Note field label for title",
  },
});
